// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"69ae4a7d","453":"57edcdfa","732":"0050ed71","977":"a759242f"}[chunkId] + ".chunk.js";
};